import { takeLatest, put, call } from 'redux-saga/effects';

import { CONFIG_SESSION } from '@handler/common/startSession';
import { storage } from '@commons/storage';
import { formatDateDDMMYYYY } from '@components/common/format';
import {
  GET_LOADING_PLANEJAMENTO_PENDING,
  GET_LOADING_PLANEJAMENTO_SUCCESS,
  RELATORIO_ATIVIDADES_PLANEJAMENTO_TALHAO_ANALITICO,
} from '../actionTypes';
import { CONST_FILTER_PLANEJAMENTO } from '@commons/consts';
import { getRelatorioAtividadesPlanejamentoTalhaoAnalitico } from '../service';

function* sagaRelatorioAtividadesTalhaoAnaliticoPlanejamento(action) {
  yield put({ type: GET_LOADING_PLANEJAMENTO_PENDING })

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;
    const idSafraAtiva = JSON.parse(storage.get(CONFIG_SESSION)).safraAtiva?.id ?? -1;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_PLANEJAMENTO) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_PLANEJAMENTO)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    let idAplicacao = ''
    if (action.idAplicacao !== undefined && action.idAplicacao !== null) {
      idAplicacao = '&id=' + action.idAplicacao
    }

    yield call(getRelatorioAtividadesPlanejamentoTalhaoAnalitico, idFazenda, idSafraAtiva, datas, filterSaved.where, idAplicacao, action.mostrarCusto ?? false)

    yield put({
      type: GET_LOADING_PLANEJAMENTO_SUCCESS
    });
  } catch (error) {
    yield put({ type: GET_LOADING_PLANEJAMENTO_SUCCESS })
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchRelatorioAtividadesTalhaoAnaliticoPlanejamento() {
  yield takeLatest(RELATORIO_ATIVIDADES_PLANEJAMENTO_TALHAO_ANALITICO, sagaRelatorioAtividadesTalhaoAnaliticoPlanejamento)
}